var footer = (function() {
"use strict";

	$('#footer').on('mouseenter mouseleave', '.partner-logo', function() {
		$(this).parent().toggleClass('hover');
	});


})();